module.exports = new __parcel__URL__("slash.03091c24.png").toString();